<template>
  <div id="MultiSelect">
    <div class="selected-items-container">
      <div v-if="selectedItems.length" class="selected-items-list">
        <button
          v-for="(item, i) in selectedItems"
          :key="i"
          class="selected-item"
          @click="handleSelect(item)"
        >
          {{ item.option_text }} <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <p class="paragraph" v-else>Your selections will appear here</p>
    </div>
    <div class="list">
      <button
        v-for="(item, i) in question.options"
        :key="i"
        class="list-item"
        :class="{ 'list-item-selected': isItemSelected(item) }"
        @click="handleSelect(item)"
      >
        <span class="item-text">{{ item.option_text }}</span>
        <span class="checkbox"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiSelect",
  props: ["setAnswer", "question"],
  data() {
    return {
      selectedItems: this.question.previous_answer || []
    };
  },
  mounted() {
    this.setAnswer(this.selectedItems)
  },
  methods: {
    handleSelect(item) {
      if (!this.selectedItems.some(el => el.option_text === item.option_text)) {
        this.selectedItems.push(item);
      } else {
        this.selectedItems = this.selectedItems.filter(el => el.option_text !== item.option_text);
      }
      this.setAnswer(this.selectedItems)
    },
    isItemSelected(item) {
      return this.selectedItems.some(el => el.option_text === item.option_text);
    }
  }
};
</script>

<style lang="less">
#MultiSelect {
  .selected-items-container {
    padding: 16px;
    border: 1px solid #c4c4c4;
    border-radius: 12px;
    box-shadow: 0px 4px 24px 0px #1e1e220d;
    margin: 0 32px 40px;

    .paragraph {
      font-family: "PlusJakartaSansRegular";
      color: #797b89;
      font-size: 1.6rem;
      margin: 0;
    }
  }

  .list {
    column-count: 2;
    column-gap: 26px;
  }

  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    break-inside: avoid;
    font-size: 1.6rem;
    font-family: "PlusJakartaSansBold";
    padding: 12px 32px;
    border: 1px solid #AEB0BD;
    border-radius: 10px;
    color: #4f4f4f;
    background-color: #fff;
    margin-bottom: 20px;

    .item-text {
      text-align: left;
      color: #797B89;
    }

    &.list-item-selected {
      border-color: #1E1E22;

      .item-text {
        text-align: left;
        color: #1E1E22;
      }

      .checkbox {
        background-color: #00D6AB;
        border-color: #00D6AB;
      }
    }
  }

  .checkbox {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #1E1E22;
  }

  .selected-items-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 0;
    margin: 0;
  }

  .selected-item {
    border: none;
    padding: 6px 14px;
    border-radius: 40px;
    color: #fff;
    font-size: 1.6rem;
    font-family: "PlusJakartaSansBold";
    background-color: #1E1E22;

    .fa {
      color: #fff;
      position: relative;
      top: 1px;
      font-size: 1.8rem;
      margin-left: 8px;
    }
  }
}
</style>
